const userManagerConfig = {
  authority: process.env.REACT_APP_AUTH_URL, // (string): The URL of the OIDC provider.
  client_id: process.env.REACT_APP_IDENTITY_CLIENT_ID,

  filterProtocolClaims: true,

  // (string, default: 'id_token'): The type of response desired from the OIDC provider.
  loadUserInfo: true,
  mergeClaims: true,

  // The URI of your client application to receive a response from the OIDC provider.
  post_logout_redirect_uri: process.env.REACT_APP_LOGOFF_REDIRECT_URL,

  // (string): Your client application's identifier as registered with the OIDC provider.
  redirect_uri: process.env.REACT_APP_REDIRECT_URL,
  // (string): The OIDC post-logout redirect URI.
  response_type: 'code',
  scope: process.env.REACT_APP_AUTH_SCOPES, // (string, default: 'openid'): The scope being requested from the OIDC provider
  silent_redirect_uri: process.env.REACT_APP_SILENT_REDIRECT_URL, // (string): The URL for the page containing the code handling the silent renew.
};

export default userManagerConfig;
